import { render, staticRenderFns } from "./BaseActivity.vue?vue&type=template&id=4cc262ed&scoped=true&"
import script from "./BaseActivity.vue?vue&type=script&lang=js&"
export * from "./BaseActivity.vue?vue&type=script&lang=js&"
import style0 from "./BaseActivity.vue?vue&type=style&index=0&id=4cc262ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc262ed",
  null
  
)

export default component.exports